module.exports = __webpack_public_path__ + "img/item4.7c588de8.jpg";